export const POST_ISSUES = "POST_ISSUES"
export const POST_ISSUES_SUCCESSFULL = "POST_ISSUES_SUCCESSFULL"
export const POST_ISSUES_FAILED = "POST_ISSUES_FAILED"

export const GET_REPORT_LIST = "GET_REPORT_LIST"
export const GET_REPORT_LIST_SUCCESS = "GET_REPORT_LIST_SUCCESS"
export const GET_REPORT_LIST_FAIL = "GET_REPORT_LIST_FAIL"
export const GET_REPORT_LIST_SEARCH = "GET_REPORT_LIST_SEARCH"

export const GET_REPORT_LIST_FILE_DATA = "GET_REPORT_LIST_FILE_DATA"
export const GET_REPORT_LIST_FILE_DATA_SUCCESS = "GET_REPORT_LIST_FILE_DATA_SUCCESS"
export const GET_REPORT_LIST_FILE_DATA_FAIL = "GET_REPORT_LIST_FILE_DATA_FAIL"

export const UPDATE_REPORT_ISSUE_STATUS ="UPDATE_REPORT_ISSUE_STATUS"
export const UPDATE_REPORT_ISSUE_STATUS_SUCCESS ="UPDATE_REPORT_ISSUE_STATUS_SUCCESS"
export const UPDATE_REPORT_ISSUE_STATUS_FAIL ="UPDATE_REPORT_ISSUE_STATUS_FAIL"

//chat modal
export const GET_CHAT_MODAL_DATA = "GET_CHAT_MODAL_DATA"
export const GET_CHAT_MODAL_DATA_CLIENT = "GET_CHAT_MODAL_DATA_CLIENT"
export const GET_CHAT_MODAL_DATA_SUCCESS = "GET_CHAT_MODAL_DATA_SUCCESS"
export const GET_CHAT_MODAL_DATA_FAIL = "GET_CHAT_MODAL_DATA_FAIL"

export const POST_MODAL_DATA = "POST_MODAL_DATA"
export const POST_MODAL_DATA_CLIENT = "POST_MODAL_DATA_CLIENT"
export const POST_MODAL_DATA_SUCCESS = "POST_MODAL_DATA_SUCCESS"
export const POST_MODAL_DATA_FAIL = "POST_MODAL_DATA_FAIL"

//delete ticket
export const GET_DELETE_TICKET = "GET_DELETE_TICKET"
export const GET_DELETE_TICKET_SUCCESS = "GET_DELETE_TICKET_SUCCESS"
export const GET_DELETE_TICKET_FAIL = "GET_DELETE_TICKET_FAIL"

//
export const LAST_JSON_TICKET_REQUEST="LAST_JSON_TICKET_REQUEST"